console.log('app.config.ts');

import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app-routing.module';
import { provideClientHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideClientHydration()]
};

import { environment } from '../environments/environment';
/**
 * Declare global configuration in a scope.
 * See custom-typings.d.ts, webpack.prod.js, and webpack.dev.js.
 *
 * Use:
 *   import * as AppConfig from "app.config";
 *   if (AppConfig.isProduction) ...
 */

/** Is this application compiled for production? */
export const isProduction: boolean = (environment.production);

/** Is this application compiled for development? */
export const isDev: boolean = !isProduction;

/** Base path to backend API */
export function baseApiUrl(): string { return environment.base_api_url;}

/**Airbrake ProjectID, used for error tracking */
export function airbrakeProjectID(): number  { return parseInt(environment.airbrake_projectid);}

/**Airbrake Key, used for error tracking */
export function airbrakeKey(): string { return environment.airbrake_key;}
